/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum InwardChargeType {
  AdmissionFee = 'AdmissionFee',

  AmbulanceCharges = 'AmbulanceCharges',

  AdministrationCharge = 'AdministrationCharge',

  BloodTransfusioncharges = 'BloodTransfusioncharges',

  CT = 'CT',

  DressingCharges = 'DressingCharges',

  Equipment = 'Equipment',

  ECG_EEG = 'ECG_EEG',

  ETUCharges = 'ETUCharges',

  GeneralIssuing = 'GeneralIssuing',

  HomeVisiting = 'HomeVisiting',

  Immunization = 'Immunization',

  IntensiveCareManagement = 'IntensiveCareManagement',

  LarbourRoomCharges = 'LarbourRoomCharges',

  LinenCharges = 'LinenCharges',

  Laboratory = 'Laboratory',

  MealCharges = 'MealCharges',

  MedicalCareICU = 'MedicalCareICU',

  MedicalServices = 'MedicalServices',

  Medicine = 'Medicine',

  MOCharges = 'MOCharges',

  MaintainCharges = 'MaintainCharges',

  DoctorAndNurses = 'DoctorAndNurses',

  NursingCharges = 'NursingCharges',

  OxygenCharges = 'OxygenCharges',

  OtherCharges = 'OtherCharges',

  OperationTheatreCharges = 'OperationTheatreCharges',

  ProfessionalCharge = 'ProfessionalCharge',

  ReimbursementCharges = 'ReimbursementCharges',

  RoomCharges = 'RoomCharges',

  physiotherapy = 'physiotherapy',

  Scanning = 'Scanning',

  TreatmentCharges = 'TreatmentCharges',

  X_Ray = 'X_Ray',

  WardProcedures = 'WardProcedures',

  CardiacMonitoring = 'CardiacMonitoring',

  Nebulisation = 'Nebulisation',

  Echo = 'Echo',

  SyringePump = 'SyringePump',

  ExerciseECG = 'ExerciseECG',

  OperationTheatreNursingCharges = 'OperationTheatreNursingCharges',

  OperationTheatreMachineryCharges = 'OperationTheatreMachineryCharges',

  TheaterConsumbale = 'TheaterConsumbale',

  VAT = 'VAT',

  AccessoryCharges = 'AccessoryCharges',

  EyeLence = 'EyeLence',

  HospitalSupportService = 'HospitalSupportService',

  ExtraMedicine = 'ExtraMedicine',

  DialysisTreatment = 'DialysisTreatment',

  Investigations = 'Investigations',

  MedicalCare = 'MedicalCare',
}
